import { html } from "html";

export class CountdownElement extends HTMLElement {
  static observedAttributes = ["data-until-time"];

  #untilTime: Date | null = null;
  #countdownDiv: HTMLElement | null = null;
  #intervalHandler: number | null = null;

  constructor() {
    super();
  }

  attributeChangedCallback(name: string, _old: string, newValue: string) {
    switch (name) {
      case "data-until-time": {
        this.#untilTime = newValue ? new Date(newValue) : null;
        this.#render();
        break;
      }
    }
  }

  connectedCallback() {
    this.#countdownDiv = this.querySelector(".dma-countdown") as HTMLElement;
    this.#intervalHandler = setInterval(() => this.#render(), 1000);
    this.#render();
  }

  disconnectedCallback() {
    clearInterval(this.#intervalHandler!);
    this.#intervalHandler = null;
    this.#countdownDiv = null;
  }

  #render() {
    if (!this.#untilTime || !this.#countdownDiv) {
      return;
    }

    const delta = timeLeft(this.#untilTime);
    if (delta === 0) {
      this.#countdownDiv.innerHTML = html`
        <time datetime="${this.#untilTime.toISOString()}">
          right now!
        </time>
      `;
      return;
    }

    const { d, h, m, s } = delta;
    this.#countdownDiv.innerHTML = html`
      <time datetime="${this.#untilTime.toISOString()}">
        <span class="dma-countdown-d">${d}</span>d
        <span class="dma-countdown-h">${h}</span>h
        <span class="dma-countdown-m">${m}</span>m
        <span class="dma-countdown-s">${s}</span>s
      </time>
    `;
  }
}

function timeLeft(untilTime: Date): {
  d: number;
  h: number;
  m: number;
  s: number;
} | 0 {
  const untilDate = new Date(untilTime);
  const now = new Date();

  let delta = Math.floor((untilDate.getTime() - now.getTime()) / 1000);
  if (delta <= 0) {
    return 0;
  }

  const d = Math.floor(delta / 86400);
  delta -= d * 86400;
  const h = Math.floor(delta / 3600) % 24;
  delta -= h * 3600;
  const m = Math.floor(delta / 60) % 60;
  delta -= m * 60;
  const s = delta % 60;

  return { d, h, m, s };
}

customElements.define("dma-countdown", CountdownElement);
